<template>
    <div class="np-form-field__wrapper">
        <div
            :class="[
                    'np-form-field', {
                    '_required': validation.required === false,
                    '_empty': !value,
                    '_error': validation.$error,
                    '_valid': validation && !validation.$error
                }]"
        >
            <input
                class="np-form-field__input"
                :value="value"
                :id="field"
                :maxlength="validation.$params.maxLength.max"
                @input="toInput"
                @change="updateInput"
                :autocomplete="autocompleteType"
                @keyup="updateInput"
                :ref="field"
                @focus="updateInput"
                v-mask="mask"
            />
            <label :for="field" class="np-form-field__label">{{ label }}</label>
        </div>
        <div v-if="validation.$error" class="np-form-field__error">
            <template v-if="validation.isCorrect === false">Только русские и английские буквы</template>
            <template v-else-if="validation.required === false">Обязательное поле</template>
            <template v-else-if="validation.maxLength === false">
                Максимальная длина - {{ validation.$params.maxLength.max }} симв.
            </template>
        </div>
    </div>
</template>

<script>
import '@/assets/js/InputmaskAliases';

export default {
    name: 'new-payment-form-field',
    props: {
        field: {
            type: String
        },
        value: {
            type: String,
            default: ''
        },
        validation: {
            type: Object
        },
        label: {
            type: String,
        },
        mask: {
            default: ''
        },
        autocompleteType: {
            type: String,
            default: 'off'
        }
    },
    model: {
        prop: 'value',
        event: 'change'
    },
    methods: {
        updateInput(e) {
            this.$emit('change', e.target.value);
            this.$emit('change-input');
        },
        toInput(e) {
            this.validation.$touch();
            this.updateInput(e);
        }
    },
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/mixins-and-vars';
$parent: '.np-form-field';

#{$parent} {
    position: relative;

    &._radio-wrapper {
        display: flex;
        margin-left: -10px;
        margin-right: -10px;
    }
    ._readonly {
        opacity: .8;
        cursor: no-drop;
    }
    &._required {
        &::after {
            content: '*';
            position: absolute;
            top: 50%;
            right: 22px;
            transform: translateY(-50%);
            margin-top: 6px;
            font-size: 25px;
            color: #FF5252;
        }
    }

    &__input {
        width: 100%;
        border-radius: 8px;
        background-color: #FFFFFF;
        border: 1px solid rgba(125, 121, 135, 0.2);
        font-weight: 500;
        transition: .2s;

        &[type=radio] {
            display: none;
        }

        @include mobile-and-more {
            padding: 25px 15px 15px;
            font-size: 18px;
        }
        @include mobile {
            padding: 20px 15px 10px;
            font-size: 16px;
        }

        ._error & {
            border-color: #FF5252;
        }
        &:not([type=checkbox]):focus,
        &:not([type=checkbox]):active,
        &-wrapper:not(._empty) &:not([type=checkbox]) {
        }
        ._required & {
            padding-right: 55px;
        }

    }

    &__wrapper {
        &:not(:first-child) {
            padding-top: 10px;
        }
        &:not(:last-child) {
            padding-bottom: 10px;
        }

        @include mobile {
            padding-top: 5px;
            padding-bottom: 5px;
        }
    }

    &__label {
        position: absolute;
        top: 50%;
        left: 15px;
        transform: translateY(-50%);
        color: rgba(125, 121, 135, 0.7);
        transition: .2s;
        pointer-events: none;

        @include mobile {
            font-size: 14px;
        }

        input:not([type=checkbox]):not([type=radio]):focus + &,
        #{$parent}:not(._empty) input:not([type=checkbox]):not([type=radio]) + & {
            @include mobile-and-more {
                top: 15px;
                font-size: 12px;
            }
            @include mobile {
                top: 13px;
                font-size: 10px;
            }
        }
    }

    &__error {
        color: $color-danger;
        font-size: 14px;
        line-height: 21px;
        animation: easeOpen .15s ease-in;
    }

    @keyframes easeOpen {
        0% {
            opacity: 0;
            max-height: 0px;

        }
        90% {
            max-height: 30px;
        }
        100% {
            opacity: 1;
            min-height: auto;
        }
    }
}
</style>